import { validateAndFormat } from "../../common/addNew/validateAndFormat";

/**
 * Actions for person
 */
export const actions = {
  /**
   * Validate form fields
   * @param {Object} context
   */
  validate(context) {
    // Step 1: Validate and format name
    const name = context.rootGetters["addNew/getName"];
    const firstName = validateAndFormat.name(
      name.firstName,
      context,
      "firstName"
    );
    const lastName = validateAndFormat.name(name.lastName, context, "lastName");

    // Validate and format phone
    const phone = validateAndFormat.allPhones(
      context.rootGetters["addNew/getPhone"],
      context
    );

    // Validate and format email
    const email = validateAndFormat.allEmails(
      context.rootGetters["addNew/getEmail"],
      context
    );

    // Validate and format timezone
    const timezone = validateAndFormat.name(
      context.rootGetters["addNew/getSelectedTimezone"],
      context
    );

    // Step 2: Set if valid or not
    context.commit(
      "setValidated",
      firstName !== false &&
        lastName !== false &&
        phone !== false &&
        email !== false &&
        timezone !== false
    );

    // Step 3: Return the formatted data
    return {
      firstName,
      lastName,
      phone,
      email,
      timezone
    };
  },
  /**
   * Send add client request
   * Data should already be formatted when sending call to this method
   * @param {Object} context
   */
  async addPerson(context, onlyThis) {
    // Step 1: Start loading
    context.commit("addNew/startLoading", null, { root: true });
    context.commit("addNew/setFormSubmitted", false, { root: true }); // Form not submitted

    // Step 2: Getting the selected provider id
    const selectedProviderId = context.rootGetters.getSelectedProviderID;

    // Step 3: Validate and format everything
    const {
      firstName,
      lastName,
      phone,
      email,
      timezone
    } = await context.dispatch("validate");

    //  Step 4: Get all the phone types and selected phone types
    const allPhoneTypes = context.rootGetters["addNew/getAllPhoneTypes"];
    const selectedPhoneTypes = context.rootGetters["addNew/getPhoneType"];

    // Step 5: Creating request data
    const requestData = {
      firstName: firstName,
      lastName: lastName,
      phone: phone,
      phoneType: selectedPhoneTypes,
      allPhoneTypes: allPhoneTypes,
      email: email,
      timezone: timezone,
      onlyThis: onlyThis,
      providerID: selectedProviderId
    };

    const addOrEdit = context.getters.getAddOrEditPerson;
    if (addOrEdit === "EDIT") {
      // Step 4: Get the client id that is to be edited
      // requestData.clientId = context.getters.getEditClientId;
      const editPersonId = context.getters.getEditPersonId;

      // Step 5: Send auth request
      const json = await context.dispatch(
        "makeAuthRequest",
        {
          url: `others/edit/${editPersonId}`,
          method: "PUT",
          data: requestData
        },
        {
          root: true
        }
      );
      if ("person" in json) {
        // Step 8: Add to form list
      } else {
        if ("message" in json) {
          context.dispatch("globalMessagePopup", json.message, {
            root: true
          });
        }
        context.commit("setValidated", false);
        return false;
      }
      /**
       * Step 6: Sending auth request
       *
       * Response format
       * {
       *   code: 200,
       *   person: {
       *      email: "", // Email 1 of the person
       *      email1: "", // Email 2 of the person
       *      first_name: "John" // First name of the person
       *      is_only: 0, // Last name of the person
       *      last_name: "Doe", // Last name of the person
       *      phone: "123-456-7890", // Phone 1 of the person
       *      phone2: "", // Phone 2 of the person
       *      phone3: "", // Phone 3 of the person
       *      phone4: "", // Phone 4 of the person
       *      pht1: "P", // Phone 1 type of the person
       *      pht2: "P", // Phone 2 type of the person
       *      pht3: "P", // Phone 3 type of the person
       *      pht4: "P", // Phone 4 type of the person
       *      timezone: "America/Denver"
       *      userID: 3542 // The provider id
       *   }
       * }
       */
      const peoples = context.rootGetters.getAppointmentType.people;
      if (!(selectedProviderId in peoples)) {
        return false;
      }

      const personIndex = peoples[selectedProviderId].findIndex(person => {
        return person.id === editPersonId;
      });

      if (personIndex === -1) {
        // Stop loading
        context.commit("addNew/stopLoading", null, {
          root: true
        });
        return false;
      }

      peoples[selectedProviderId][personIndex].email = email;
      peoples[selectedProviderId][personIndex].first_name = firstName;
      peoples[selectedProviderId][personIndex].id = editPersonId;
      peoples[selectedProviderId][personIndex].last_name = lastName;
      peoples[selectedProviderId][
        personIndex
      ].name = `${lastName}, ${firstName}`;
      peoples[selectedProviderId][personIndex].phone = [
        json.person.phone,
        json.person.phone2,
        json.person.phone3,
        json.person.phone4
      ];
      peoples[selectedProviderId][personIndex].pht = [
        json.person.pht1,
        json.person.pht2,
        json.person.pht3,
        json.person.pht4
      ];
      peoples[selectedProviderId][personIndex].provider = selectedProviderId;
      peoples[selectedProviderId][personIndex].timezone = timezone;
      var person_user_id = peoples[selectedProviderId][personIndex].user_id;

      //update chats
      if (person_user_id !== 0) {
        context.commit(
          "chat/updateNewClient",
          {
            value: {
              firstName: json.person.first_name,
              lastName: json.person.last_name
            },
            clientId: person_user_id
          },
          { root: true }
        );
      }
    } else {
      const json = await context.dispatch(
        "makeAuthRequest",
        {
          url: "others/add",
          method: "POST",
          data: requestData
        },
        { root: true }
      );
      /**
       * Step 6: Sending auth request
       *
       * Response format
       * {
       *   code: 200,
       *   person: {
       *      id: 527, // Id of the person
       *      firstName: "John" // First name of the person
       *      lastName: "Doe", // Last name of the person
       *      email: "", // Email 1 of the person
       *      email1: "", // Email 2 of the person
       *      phone: "123-456-7890", // Phone 1 of the person
       *      phone2: "", // Phone 2 of the person
       *      phone3: "", // Phone 3 of the person
       *      phone4: "", // Phone 4 of the person
       *      pht1: "P", // Phone 1 type of the person
       *      pht2: "P", // Phone 2 type of the person
       *      pht3: "P", // Phone 3 type of the person
       *      pht4: "P", // Phone 4 type of the person
       *      providerID: 3159 // The provider id
       *   }
       * }
       */
      // Step 7: Insert into form details if required
      if ("person" in json) {
        const person = {
          email: json.person.email,
          email2: json.person.emai2,
          firstName: firstName,
          id: json.person.id,
          lastName: lastName,
          middleName: "",
          namePrefix: "",
          nameSuffix: "",
          phones: [
            json.person.phone,
            json.person.phone2,
            json.person.phone3,
            json.person.phone4
          ],
          pht1: json.person.pht1,
          pht2: json.person.pht2,
          pht3: json.person.pht3,
          pht4: json.person.pht4,
          providerID: json.person.providerID,
          status: 1,
          favourite_id: 0,
          timezone: json.person.timezone
        };

        // Step 8: Add to form list
        context.commit(
          "addToPersonListInForm",
          { person, providerId: selectedProviderId, onlyThis },
          { root: true }
        );
      } else {
        if ("message" in json) {
          context.dispatch("globalMessagePopup", json.message, {
            root: true
          });
        }
        context.commit("setValidated", false);
        return false;
      }
    }
    // Step 9: Stop loading
    context.commit("addNew/setFormSubmitted", true, { root: true });
    context.commit("addNew/stopLoading", null, { root: true });
    context.commit("setValidated", false);
    return true;
  },

  //Trigerreg when a person contact is clicked. Used to fetch everything from data to state for edit person form.
  editPerson(context, id) {
    // Step 0: Getting the selected provider id
    const selectedProviderId = context.rootGetters.getSelectedProviderID;

    // Step 1: Getting all the person
    const peoples = context.rootGetters.getAppointmentType.people;
    if (!(selectedProviderId in peoples)) {
      return false;
    }

    // Step 2: Getting the client
    const people = peoples[selectedProviderId].find(curClient => {
      return curClient.id === id;
    });
    const allPhoneTypes = context.rootGetters["addNew/getAllPhoneTypes"];

    // Step 3: Create the request data
    var phones = [
      people.phone[0],
      people.phone[1],
      people.phone[2],
      people.phone[3]
    ].filter(phone => {
      return phone !== "" && phone !== null;
    });
    const reqData = {
      firstName: people.first_name,
      lastName: people.last_name,
      phone: phones,
      phoneType: [
        people.pht[0],
        people.pht[1],
        people.pht[2],
        people.pht[3]
      ].map(pht => {
        switch (pht) {
          case "C":
            return 1;

          case "H":
            return 2;

          case "W":
            return 3;

          case "F":
            return 4;

          case "O":
            return 5;

          default:
            return 0;
        }
      }),
      allPhoneTypes: allPhoneTypes,
      email: [
        people.email[0],
        people.email[1],
        people.email[2],
        people.email[3]
      ],
      timezone: people.timezone,
      // onlyThis: onlyThis,
      providerID: selectedProviderId
    };
    context.commit("addNew/setEdit", reqData, {
      root: true
    });
    context.commit("setAddOrEditPerson", "EDIT");
    context.commit("setEditPersonId", people.id);
  },

  // Make the person mode to add
  setToAddPersonMode(context) {
    context.commit("setAddOrEditPerson", "ADD");
    context.commit("setEditPersonId", 0);
  }
};
